/**
 * Stato del thread di notifica SRP: etichette, badge e distinzione aperto/chiuso condivisi da
 * lista, dettaglio e storico della release.
 */

import type { SrpReport, ThreadStatus } from './types.js';
import styles from './Srp.module.css';

/** Stato effettivo del thread, trattando assente/undefined come 'open'. */
export function statoEffettivo(report: Pick<SrpReport, 'threadStatus'>): ThreadStatus {
  return report.threadStatus ?? 'open';
}

/**
 * True se il thread è chiuso (risolto o non necessario): è un report «precedente», ancora
 * consultabile e modificabile dal dettaglio.
 */
export function isThreadChiuso(report: Pick<SrpReport, 'threadStatus'>): boolean {
  const stato = statoEffettivo(report);
  return stato === 'resolved' || stato === 'not_needed';
}

/**
 * Etichetta dello stato del thread. `open` è «Bozza»: la piattaforma non trasmette nulla a ENISA,
 * quindi un thread aperto è sempre una bozza dal punto di vista di ENISA (vedi tooltipThread).
 */
export function etichettaThread(status: ThreadStatus): string {
  if (status === 'open') return 'Bozza';
  if (status === 'pending_investigation') return 'In attesa di approfondimento';
  if (status === 'resolved') return 'Risolto';
  return 'Non necessario';
}

/** Tooltip dello stato del thread (solo `open` ne ha uno). */
export function tooltipThread(status: ThreadStatus): string | undefined {
  if (status === 'open') return 'non ancora notificata a ENISA, notifiche interne inoltrate';
  return undefined;
}

export function classeBadgeThread(status: ThreadStatus): string {
  const b = styles.badge ?? '';
  if (status === 'open') return `${b} ${styles.badgePendingReview ?? ''}`;
  if (status === 'pending_investigation') return `${b} ${styles.badgeDraft ?? ''}`;
  if (status === 'resolved') return `${b} ${styles.badgeApproved ?? ''}`;
  return `${b} ${styles.badgeSent ?? ''}`;
}

/** Data breve (gg/mm/aaaa) di un istante ISO; '—' se assente o non valido. */
export function dataBreve(iso: string | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '—' : d.toLocaleDateString('it-IT');
}
